import config from "../common/Config";
import useAuth from "../hooks/useAuth"
import { useLocation, useNavigate } from "react-router-dom"

const useExternalFetch = () => {
	const { auth, setAuth } 	= useAuth();
	const navigate			 	= useNavigate()
	const location 				= useLocation()

	const externalFetch = async (dstUrl, dstOptions) => {
		const options =  {
			method : 'POST',
			headers : {
				'content-type' 	: 'application/json; charset=utf-8',
				'authorization' : 'Bearer '+ auth.accessToken,
			},
			body : JSON.stringify({ dstUrl, dstOptions})
		}
	
		const tryAccessToken = await fetch(config.apiUrl +'/externalApi', options)
		
		if (tryAccessToken.status == 200) {
			return tryAccessToken
		}
		else if (tryAccessToken.status == 429) {
			navigate('/error/tooManyRequests')
			return { 
				status		: 429,
				message 	: "Muitas Conexões! Tente novamente mais tarde."
			}
		}		
		else {
			return await fetch(config.apiUrl +'/refresh', { credentials : 'include'})
			.then(async returnObject => {
				if (returnObject.status == 200) {
					const data = await returnObject.json()

					setAuth({
						userId			: data.userId, 
						user			: data.user,
						accessToken 	: data.accessToken
					})

					options.headers['authorization'] = 'Bearer '+  data.accessToken

					return await fetch(config.apiUrl +'/externalApi', options)
					.then(result => {
						if (result.status === 429) navigate('/error/tooManyRequests')
						return result
					})
				}
				else if (returnObject.status == 429) {
					navigate('/error/tooManyRequests')
					return { 
						status		: 429,
						message 	: "Muitas Conexões! Tente novamente mais tarde."
					}
				}				
				else {
					// Em caso de token expirado, atualzia o browser para fazer a validação do token 
					// vai RequireAuth.js. Aguarda 2s pois continua o processamento do client side, 
					// mesmo apos redirect
					window.location.reload();
					await new Promise(r => setTimeout(r, 2000));

					return { 
						json : () => { 
							return { 
								message : "Falha na autenticação! Efetuar novo login!"
							}
						}
					}
				}

			})

		}
	}

	return externalFetch
}

export default useExternalFetch

